import actions from './actions';

const initState = {
  idToken: null,
  userProfile: null,
  planName: 'SARi',
  isAdminCentro: false,
};

export default function authReducer(state = initState, action) {
  switch (action.type) {
    case actions.LOGIN_SUCCESS:
      return {
        ...state,
        idToken: action.token,
      };
    case actions.SET_USER_PROFILE:
      const profile = action.payload;
      const metadata = profile?.['https://api-auth.icancha.com/metadata'] || {};
      const isAdminCentro = metadata.roleid === 2 || metadata.roleid === 1;

      const standard = [2, 9];
      const premium = [1, 4, 6, 10];
      const basic = [3, 7, 8];

      let planName = 'SARi';
      if (standard.includes(metadata.planid)) {
        planName = 'Standard';
      } else if (premium.includes(metadata.planid)) {
        planName = 'Premium';
      } else if (basic.includes(metadata.planid)) {
        planName = 'Basic';
      }

      return {
        ...state,
        userProfile: profile,
        planName,
        isAdminCentro,
      };
    case actions.LOGOUT:
      return initState;
    default:
      return state;
  }
}
